module.exports = __webpack_public_path__ + "img/logo2.35a9d54b.png";